<template>
  <div :class="divWidthChange" class="conteudoWidth">
    <fccTitlePage :titlePage="titlePage" />
    <div class="row">
      <div class="col-sm-12">
        <fccTable
          striped
          hover
          :fields="fieldsOrgaoExpedidor"
          responsive
          :porPage="itemPorPage"
          search
          pagination
          fieldVisibility
          pdf
          csv
          xls
          :titlePage="titlePage"
          :titlePDF="titlePDF"
          :actions="actionsOrgaoExpedidor"
          addFilter
          :items="listarOrgaoExpedidor"
        >
          <template #tipo="{ row, value }"> {{ filtrarTipo(value) }} </template>
        </fccTable>
      </div>
    </div>
    <fccModal
      centered
      idModal="editOrgaoExpedidor"
      :titleModal="titleModal"
      escondeFooter
      travaEsc
      travaBack
    >
      <form
        @submit.prevent="orgaoExpedidor.id === 0 ? addOrgaoExpedidor() : editandoOrgaoExpedidor()"
        autocomplete="off"
      >
        <div class="row innerPage">
          <div class="col-sm-12">
            <fccInput extraClasses="inputLabel" v-model="orgaoExpedidor.sigla" required
              >Sigla</fccInput
            >
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12">
            <fccInput extraClasses="inputLabel" v-model="orgaoExpedidor.nome" required
              >Nome</fccInput
            >
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12">
            <fcc-select
              class="mb-4"
              placeholder="Selecione o Tipo"
              labelField="nome"
              valueField="id"
              extraClasses="inputLabel"
              :clearable="false"
              v-model="orgaoExpedidor.tipo"
              :options="tiposOrgaoExpedidor"
              required
            >
              Tipo
            </fcc-select>
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12 text-right">
            <fccButton classeAdd="form-control" tipo="submit">{{ labelsSystem.salvar }}</fccButton>
          </div>
        </div>
      </form>
    </fccModal>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Órgão Expedidor',
      titleModal: '',
      titlePDF: 'Órgão Expedidor',
      listarOrgaoExpedidor: [],
      baseUrlGestaoProjetosConcurso: '',
      orgaoExpedidor: [],
      tiposOrgaoExpedidor: [
        {
          id: 1,
          nome: 'Orgão Federal'
        },
        {
          id: 2,
          nome: 'Orgão Regional'
        },
        {
          id: 3,
          nome: 'Orgão Municipal'
        },
        {
          id: 4,
          nome: 'Estrangeiro / Outro'
        }
      ],
      itemPorPage: '100',
      actionsOrgaoExpedidor: [
        {
          button: true,
          funcaoButton: 'editOrgaoExpedidor',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteOrgaoExpedidor',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      fieldsOrgaoExpedidor: [
        { key: 'id', label: 'ID', sortable: true, active: true },
        { key: 'sigla', label: 'Sigla', sortable: true, active: true },
        { key: 'nome', label: 'Nome', sortable: true, active: true },
        { key: 'tipo', label: 'tipo', sortable: true, active: true, type: 'slot' },
        { key: 'actions', label: '', tdClass: 'no-print', thClass: 'no-print', active: true }
      ]
    }
  },
  methods: {
    filtrarTipo(valor) {
      return this.tiposOrgaoExpedidor.find((element) => element.id == valor).nome
    },
    linstandoOrgaoExpedidor() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlGestaoProjetosConcurso + 'OrgaoExpedidor/Listar',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listarOrgaoExpedidor = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    addField() {
      this.titleModal = 'Adicionar Órgão Expedidor'
      this.orgaoExpedidor = {}
      this.orgaoExpedidor.id = 0
      this.$root.$emit('bv::show::modal', 'editOrgaoExpedidor')
    },
    editOrgaoExpedidor(_, item) {
      this.titleModal = 'Editar Órgão Expedidor'
      this.orgaoExpedidor = item
      this.$root.$emit('bv::show::modal', 'editOrgaoExpedidor')
    },
    editandoOrgaoExpedidor() {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .put(
          this.baseUrlGestaoProjetosConcurso + 'OrgaoExpedidor/Alterar',
          this.orgaoExpedidor,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.orgaoExpedidor = {}
          this.callToast(this.mensagensUpdate.editado, 'success')
          this.$root.$emit('bv::hide::modal', 'editOrgaoExpedidor')
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto())
    },
    addOrgaoExpedidor() {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          this.baseUrlGestaoProjetosConcurso + 'OrgaoExpedidor/Adicionar',
          this.orgaoExpedidor,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.orgaoExpedidor = {}
          this.linstandoOrgaoExpedidor()
          this.callToast(this.mensagensUpdate.adicionado, 'success')
          this.$root.$emit('bv::hide::modal', 'editOrgaoExpedidor')
        })
        .catch((error) => {
          this.setErrorSystem(error)
        })
        .finally(this.carregaTexto())
    },
    deleteOrgaoExpedidor(_, item) {
      this.callConfirm(this.mensagemExcluir, item.nome).then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C03'))
          axios
            .delete(
              this.baseUrlGestaoProjetosConcurso + 'OrgaoExpedidor/Excluir/' + item.id,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.linstandoOrgaoExpedidor()
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
            .finally(this.carregaTexto())
        }
      })
    }
  },
  mounted() {
    this.baseUrlGestaoProjetosConcurso = store.state.baseUrlGestaoProjetos
    this.linstandoOrgaoExpedidor()
  }
}
</script>
